<div class="sidenav-progress-bar">
    <p class="progress-bar-title width-p-50 fs-12 p-b-2">{{ displayVersion | titlecase }} version</p>
    <p class="progress-bar-number fs-12 p-b-2 text-end">{{ totalAnswered + '/' + numberOfQuestions }}</p>
    <app-mdr-progress-bar
        [maxValue]="numberOfQuestions"
        [value]="totalAnswered"
    ></app-mdr-progress-bar>
</div>
